/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {bulkUpdateEscalationTickets} from '../api'

export const useMutationBulkUpdateEscalationTickets = createReactQueryMutationHook('bulkUpdateEscalationTickets', bulkUpdateEscalationTickets)
